import React, { useEffect } from 'react'
import { MenuItem, TextField } from '@mui/material'
import { TypeMovement } from '../../interfaces/TypeMovement'
import { useTypeMovement } from '../../hooks'

interface TypeMovementDDLProps {
  onChange: any
  value: any
  withoutThisPositions?: number[]
  fullWidth?: boolean
  variant?: 'outlined' | 'standard' | 'filled'
}

export const TypeMovementDDL: React.FC<TypeMovementDDLProps> = ({
  onChange,
  value,
  withoutThisPositions = [],
  fullWidth = false,
  variant = 'standard'
}) => {
  // > GET TYPE MOVEMENT
  const {
    typeMovementsState: { typeMovements },
    getTypeMovements
  } = useTypeMovement()

  useEffect(() => {
    if (typeMovements?.length === 0) {
      getTypeMovements()
    }
  }, [])

  const arrTypePositions =
    typeMovements !== undefined
      ? typeMovements
          .filter((item) => !withoutThisPositions.includes(item.typeMovementId))
          .map((option: TypeMovement) => (
            <MenuItem key={option.typeMovementId} value={option.typeMovementId}>
              {option.description}
            </MenuItem>
          ))
      : []

  return (
    <TextField
      id='typeMovementId'
      name='typeMovementId'
      select
      value={value}
      onChange={onChange}
      variant={variant}
      fullWidth={fullWidth}
    >
      <MenuItem key={-1} value={-1}>
        {'Seleccionar Tipo Movimiento...'}
      </MenuItem>
      {arrTypePositions}
    </TextField>
  )
}
